import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Form, Input, Select } from "antd";
import axios from "axios";
import AppHeader from "../../../components/Dashboard/AppHeader";
import FormButton from "../../../components/Form/FormButton";

const { TextArea } = Input;
const { Option } = Select;

const Announcement = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [form] = Form.useForm();
  const [visibleAudience, setVisibleAudience] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleAudienceChange = (value) => {
    if (value.includes("All")) {
      setVisibleAudience(["All"]);
      form.setFieldsValue({ targetAudience: ["All"] });
    } else {
      setVisibleAudience(value);
      form.setFieldsValue({ targetAudience: value });
    }
  };

  const onFinish = async (values) => {
    const actualAudience = values.targetAudience.includes("All")
      ? ["student", "teacher", "parent"]
      : values.targetAudience;

    const payload = {
      title: values.title,
      message: values.message,
      targetAudience: actualAudience,
    };

    setLoading(true);

    try {
      const res = await axios.post("http://localhost:5000/api/createAnnouncement", payload);
      console.log("Announcement published:", res.data);
      form.resetFields();
      setVisibleAudience([]); 
    } catch (error) {
      console.error("Error publishing announcement:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <>
      <AppHeader
        title={"Announcement"}
        content={
          "Purpose: Display performance reports of all students for evaluation purposes."
        }
      />

      <Typography variant="h5" fontWeight="bold" mb={-3}>
        Announcement
      </Typography>

      <Box
        sx={{
          width: isMobile ? "100%" : "69%",
          mt: 5,
          p: 3,
          border: "2px solid black",
          borderRadius: 2,
          boxShadow: "2px 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Form.Item
                name="title"
                label="Announcement Title"
                rules={[{ required: true, message: "Please enter title" }]}
              >
                <Input placeholder="Enter announcement title" />
              </Form.Item>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Item
                name="targetAudience"
                label="Target Audience"
                rules={[{ required: true, message: "Please select audience" }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select Target Audience"
                  value={visibleAudience}
                  onChange={handleAudienceChange}
                >
                  <Option value="All">All</Option>
                  <Option value="student">Student</Option>
                  <Option value="teacher">Teacher</Option>
                  <Option value="parent">Parent</Option>
                </Select>
              </Form.Item>
            </Grid>

            <Grid item xs={12}>
              <Form.Item
                name="message"
                label="Message"
                rules={[{ required: true, message: "Please enter message" }]}
              >
                <TextArea rows={6} />
              </Form.Item>
            </Grid>
          </Grid>

          <Box mt={2}>
            <FormButton
              text="Publish Announcement"
              backgroundColor="#22C55E"
              borderColor="black"
              width={isMobile ? "100%" : "auto"}
              loading={loading} 
            />
          </Box>
        </Form>
      </Box>
    </>
  );
};

export default Announcement;
